/**
 * Coerces null fund fields to undefined.
 * GraphQL returns null for missing fields; our Zod schemas expect undefined.
 */
export const normalizeFund = (
  fund: Record<string, unknown> | null | undefined,
) => {
  if (fund == null) {
    return null;
  }
  if (fund['fundCodeOneTime'] == null) {
    return null;
  }
  return {
    ...fund,
    fundCodeCommitment: fund['fundCodeCommitment'] ?? undefined,
    catalogAmount: fund['catalogAmount'] ?? undefined,
  };
};

/**
 * Normalizes an array of search result items by coercing null fund fields.
 * Preserves the input item type via generics.
 */
export const normalizeItems = <T extends Record<string, unknown>>(
  items: T[],
): (Omit<T, 'fund'> & { fund: ReturnType<typeof normalizeFund> })[] =>
  items.map((item) => ({
    ...item,
    fund: normalizeFund(
      item['fund'] as Record<string, unknown> | null | undefined,
    ),
  }));
